<template>
  <button class="primary-button flex-all-center">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "PrimaryButton",
};
</script>

<style scoped>
.primary-button {
  width: 100%;
  height: 60px;
  font-size: 20px;
  color: var(--defaultBlackColor);
  border: solid 2px var(--defaultBlackColor);
  background-color: transparent;
  &:hover {
    color: var(--defaultWhiteColor);
    border: solid 2px var(--defaultBlackColor);
    background-color: var(--defaultBlackColor);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/oauth/PrimaryButton.vue